import { render, staticRenderFns } from "./zendesk.vue?vue&type=template&id=1a599287&scoped=true"
import script from "./zendesk.vue?vue&type=script&lang=js"
export * from "./zendesk.vue?vue&type=script&lang=js"
import style0 from "./zendesk.vue?vue&type=style&index=0&id=1a599287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a599287",
  null
  
)

export default component.exports